module.exports = __webpack_public_path__ + "static/media/logo.7dc92b2a.png";